import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Profile from '../views/Profile.vue'
import Account from '../views/Account.vue'
import About from '../views/About.vue'
import faq from '../views/faq.vue'
import privacyPolicy from '../views/privacyPolicy.vue'
import contactUs from '../views/contactUs.vue'
import Special from '../views/Special.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      guest: true
    }
  },
  
  {
    path: '/category/:slug/:id',
    name: 'category',
    component: Home,
    meta: {
      guest: true
    }

  },

  {
    path: '/about-us',
    name: 'about',
    component: About,
    meta: {
      guest: true
    }
  },
  {
    path: '/faq',
    name: 'faq',
    component: faq,
    meta: {
      guest: true
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: privacyPolicy,
    meta: {
      guest: true
    }
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: contactUs,
    meta: {
      guest: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/account',
    name: 'account',
    component: Account,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/special',
    name: 'special',
    component: Special,
    meta: {
      guest: true
    }
  }

]

const router = new VueRouter({
  // mode: 'history',
  routes,
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
      if(sessionStorage.getItem('access_token') === null) {
        next({ name: 'home'})
      }else{
        next() 
      } 
  } else if(to.matched.some(record => record.meta.guest)) {
    next()
  }
})
export default router
